"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisableFocusWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.DisableFocusWrapper = components_core_1.styled.div `
  ${(props) => props.displayFocus && `display: ${props.displayFocus};`}

  /* General focus cases */
  & :focus {
    outline: none !important;
  }

  /* For input component from component-core */
  input ~ span {
    outline: none !important;
  }

  /* Components that don't use :focus */
  outline: none !important;

  /* Fixing issue with input bottom line */
  label input ~ div {
    min-height: 1px;
  }
`;
